export default {
  placeholder: 'Vybrať úrovne závažnosti',
};
